var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.65052 5.54582L10.5443 9.43982C10.7977 9.69311 10.7977 10.1026 10.5443 10.3559C10.291 10.6092 9.88152 10.6092 9.62823 10.3559L5.73432 6.46193L1.84052 10.3559C1.58711 10.6092 1.17771 10.6092 0.924426 10.3559C0.671025 10.1026 0.671025 9.69311 0.924426 9.43982L4.81823 5.54582L0.924426 1.65183C0.671025 1.39854 0.671025 0.989005 0.924426 0.735717C1.05065 0.609369 1.21662 0.545898 1.38247 0.545898C1.54832 0.545898 1.71417 0.609369 1.84052 0.735717L5.73432 4.62971L9.62823 0.735717C9.75458 0.609369 9.92043 0.545898 10.0863 0.545898C10.2521 0.545898 10.418 0.609369 10.5443 0.735717C10.7977 0.989005 10.7977 1.39854 10.5443 1.65183L6.65052 5.54582Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/closeBlack.c4c1a51c3c949ce9bf3af5720b531753.svg";
export { ForwardRef as ReactComponent };